import { useEffect, useLayoutEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "./db";
import { uid } from "uid";
import { ref, update, onValue } from "firebase/database";
import { animated, useSpring } from "@react-spring/web";

function Game() {
  var my_key = sessionStorage.getItem("my_key");
  var my_name = sessionStorage.getItem("my_name");

  const [name, setName] = useState(my_name);

  useEffect(() => {
    if (my_key === null) {
      sessionStorage.setItem("my_key", uid());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const id = useParams();

  const arrays = [
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
  ];

  const [array, setArray] = useState(arrays);

  const [thirdPart, setThirdPart] = useState(false);

  const [buttons, setButtons] = useState([0, 0, 0, 0, 0, 0]);

  const [player, setPlayer] = useState(false);

  const [replay, setReplay] = useState(false);

  const [activePlayer, setActivePlayer] = useState();

  const [waitForReplay, setWaitForReplay] = useState(false);

  const [finished, setFinished] = useState(false);

  const [notification, setNotification] = useState(false);

  const [playerOne, setPlayerOne] = useState();

  const [playerOneScore, setPlayerOneScore] = useState(0);

  const [playerTwo, setPlayerTwo] = useState();

  const [playerTwoScore, setPlayerTwoScore] = useState(0);

  const [playerOneName, setPlayerOneName] = useState();

  const [playerTwoName, setPlayerTwoName] = useState();

  const [draw, setDraw] = useState(false);

  const [robotPlayer, setRobotPlayer] = useState(false);

  useLayoutEffect(() => {
    onValue(ref(db, "/" + id.id), (snapshot) => {
      const datas = snapshot.val();
      setArray(datas.array);
      setButtons(datas.buttons);
      setPlayer(datas.player);
      setFinished(datas.finished);
      setReplay(datas.replay);
      setPlayerOne(datas.playerOne);
      setPlayerTwo(datas.playerTwo);
      setPlayerOneName(datas.playerOneName);
      setPlayerTwoName(datas.playerTwoName);
      setDraw(datas.draw);
      setPlayerOneScore(datas.playerOneScore);
      setPlayerTwoScore(datas.playerTwoScore);
      setRobotPlayer(datas.robotPlayer);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeButtonValue = (index) => {
    changeColor(index, buttons[index]);
    buttons[index] = buttons[index] + 1;
    update(ref(db, `/${id.id}`), {
      buttons: buttons,
    });
  };

  const winner = () => {
    if (replay) {
      setArray([
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
      ]);
      setButtons([0, 0, 0, 0, 0, 0]);
      setPlayer(false);
      setDraw(false);
      update(ref(db, `/${id.id}`), {
        array: arrays,
        buttons: [0, 0, 0, 0, 0, 0],
        finished: false,
        replay: false,
        draw: false,
      });
      setWaitForReplay(false);
    } else {
      update(ref(db, `/${id.id}`), {
        replay: !replay,
      });
      setWaitForReplay(true);
    }
  };

  useEffect(() => {
    if (!replay) {
      setWaitForReplay(false);
      return;
    }
    if (!replay && robotPlayer) {
      setWaitForReplay(true);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replay]);

  const won = (status) => {
    setFinished(true);
    update(ref(db, `/${id.id}`), {
      finished: true,
      playerOneScore: !status
        ? playerOneScore
        : !player
        ? playerOneScore + 1
        : playerOneScore,
      playerTwoScore: !status
        ? playerTwoScore
        : player
        ? playerTwoScore + 1
        : playerTwoScore,
    });
  };

  const changeColor = (index, item) => {
    let wonOrDraw = false;
    array[item][index] = player;
    setPlayer(!player);
    //check winner in rows line
    if (index === 0) {
      if (
        array[item][index] === array[item][index + 3] &&
        array[item][index] === array[item][index + 2] &&
        array[item][index] === array[item][index + 1]
      ) {
        wonOrDraw = true;
      }
    } else if (index === 5) {
      if (
        array[item][index] === array[item][index - 3] &&
        array[item][index] === array[item][index - 2] &&
        array[item][index] === array[item][index - 1]
      ) {
        wonOrDraw = true;
      }
    } else if (index === 1) {
      if (
        array[item][index] === array[item][index + 2] &&
        array[item][index] === array[item][index + 1] &&
        array[item][index] === array[item][index - 1]
      ) {
        wonOrDraw = true;
      } else if (
        array[item][index] === array[item][index + 1] &&
        array[item][index] === array[item][index + 2] &&
        array[item][index] === array[item][index + 3]
      ) {
        wonOrDraw = true;
      } else {
      }
    } else if (index === 4) {
      if (
        array[item][index] === array[item][index + 1] &&
        array[item][index] === array[item][index - 1] &&
        array[item][index] === array[item][index - 2]
      ) {
        wonOrDraw = true;
      } else if (
        array[item][index] === array[item][index - 1] &&
        array[item][index] === array[item][index - 2] &&
        array[item][index] === array[item][index - 3]
      ) {
        wonOrDraw = true;
      } else {
      }
    } else {
      if (
        array[item][index] === array[item][index + 2] &&
        array[item][index] === array[item][index + 1] &&
        array[item][index] === array[item][index - 1]
      ) {
        wonOrDraw = true;
      } else if (
        array[item][index] === array[item][index - 2] &&
        array[item][index] === array[item][index - 1] &&
        array[item][index] === array[item][index + 1]
      ) {
        wonOrDraw = true;
      } else if (
        array[item][index] === array[item][index - 1] &&
        array[item][index] === array[item][index - 2] &&
        array[item][index] === array[item][index - 3]
      ) {
        wonOrDraw = true;
      } else if (
        array[item][index] === array[item][index + 3] &&
        array[item][index] === array[item][index + 2] &&
        array[item][index] === array[item][index + 1]
      ) {
        wonOrDraw = true;
      } else {
      }
    }
    //check winner in columns line
    if (item >= 3) {
      if (
        array[item][index] === array[item - 3][index] &&
        array[item][index] === array[item - 2][index] &&
        array[item][index] === array[item - 1][index]
      ) {
        wonOrDraw = true;
      }
    }
    //check winner in x lines
    //from right to left or from right to left
    if (
      item > 1 &&
      item < 4 &&
      index > 1 &&
      index < 5 &&
      array[item][index] === array[item - 2][index - 2] &&
      array[item][index] === array[item - 1][index - 1] &&
      array[item][index] === array[item + 1][index + 1]
    ) {
      wonOrDraw = true;
    }
    if (
      item > 0 &&
      item < 3 &&
      index > 0 &&
      index < 3 &&
      array[item][index] === array[item + 2][index + 2] &&
      array[item][index] === array[item - 1][index - 1] &&
      array[item][index] === array[item + 1][index + 1]
    ) {
      wonOrDraw = true;
    }
    if (
      item > 2 &&
      index > 2 &&
      array[item][index] === array[item - 1][index - 1] &&
      array[item][index] === array[item - 3][index - 3] &&
      array[item][index] === array[item - 2][index - 2]
    ) {
      wonOrDraw = true;
    }
    if (
      item < 2 &&
      index < 3 &&
      array[item][index] === array[item + 1][index + 1] &&
      array[item][index] === array[item + 3][index + 3] &&
      array[item][index] === array[item + 2][index + 2]
    ) {
      wonOrDraw = true;
    }
    if (
      item > 1 &&
      item < 4 &&
      index > 0 &&
      index < 4 &&
      array[item][index] === array[item - 2][index + 2] &&
      array[item][index] === array[item - 1][index + 1] &&
      array[item][index] === array[item + 1][index - 1]
    ) {
      wonOrDraw = true;
    }
    if (
      item < 3 &&
      item > 0 &&
      index > 1 &&
      index < 5 &&
      array[item][index] === array[item + 2][index - 2] &&
      array[item][index] === array[item - 1][index + 1] &&
      array[item][index] === array[item + 1][index - 1]
    ) {
      wonOrDraw = true;
    }
    if (
      item > 2 &&
      index < 3 &&
      array[item][index] === array[item - 1][index + 1] &&
      array[item][index] === array[item - 3][index + 3] &&
      array[item][index] === array[item - 2][index + 2]
    ) {
      wonOrDraw = true;
    }
    if (
      item < 2 &&
      index > 2 &&
      array[item][index] === array[item + 1][index - 1] &&
      array[item][index] === array[item + 3][index - 3] &&
      array[item][index] === array[item + 2][index - 2]
    ) {
      wonOrDraw = true;
    }
    const sum = buttons.reduce((partialSum, a) => partialSum + a, 0);
    if (wonOrDraw) {
      won(true);
    }
    if (wonOrDraw === false && sum === 29) {
      won(false);
    }
    update(ref(db, `/${id.id}`), {
      array: array,
      buttons: buttons,
      player: !player,
      draw: wonOrDraw === false && sum === 29 ? true : false,
    });
  };

  useEffect(() => {
    if (playerOne !== undefined && playerTwo !== undefined && name !== null) {
      if (playerOne === "" && my_name !== null && my_key !== playerTwo) {
        update(ref(db, `/${id.id}`), {
          playerOne: my_key,
          playerOneName: my_name,
        });
        setActivePlayer(false);
      } else if (playerTwo === "" && my_name !== null && my_key !== playerOne) {
        update(ref(db, `/${id.id}`), {
          playerTwo: my_key,
          playerTwoName: my_name,
        });
        setActivePlayer(true);
      } else {
        if (my_key === playerOne) {
          setActivePlayer(false);
        } else if (my_key === playerTwo) {
          setActivePlayer(true);
        } else {
          setThirdPart(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playerOne, playerTwo, name]);

  const putInColumn = (value) => {
    if (player === activePlayer && buttons[value] < 5) {
      changeButtonValue(parseInt(value));
      setPositionY(buttons[value]);
      setPositionX(parseInt(value));
      setToBottom(true);
      return;
    }
    if (player && robotPlayer) {
      changeButtonValue(parseInt(value));
      setPositionY(buttons[value]);
      setPositionX(parseInt(value));
      setToBottom(true);
      return;
    }
  };

  const [toBottom, setToBottom] = useState(false);
  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);

  const [y, setY] = useState("8px");
  const [mobileY, setMobileY] = useState("4px");
  const x1 = "8px";
  const x2 = "120px";
  const x3 = "232px";
  const x4 = "344px";
  const x5 = "456px";
  const x6 = "568px";
  const mobileX1 = "4px";
  const mobileX2 = "60px";
  const mobileX3 = "116px";
  const mobileX4 = "172px";
  const mobileX5 = "228px";
  const mobileX6 = "284px";

  useEffect(() => {
    setY((5 - positionY) * 104 + (5 - positionY) * 8 + "px");
    setMobileY((5 - positionY) * 52 + (5 - positionY) * 4 + "px");
  }, [positionY]);

  const mobileState = window.innerWidth > 766;

  const styles = useSpring({
    top: mobileState ? (toBottom ? y : "-128px") : toBottom ? mobileY : "-80px",
    visibility: toBottom ? "" : "hidden",
    config: { duration: 500 },
    onRest: () => {
      setToBottom(false);
    },
  });

  const style1 = useSpring({
    left: mobileState ? x1 : mobileX1,
    display: positionX === 0 ? "" : "none",
  });
  const style2 = useSpring({
    left: mobileState ? x2 : mobileX2,
    display: positionX === 1 ? "" : "none",
  });
  const style3 = useSpring({
    left: mobileState ? x3 : mobileX3,
    display: positionX === 2 ? "" : "none",
  });
  const style4 = useSpring({
    left: mobileState ? x4 : mobileX4,
    display: positionX === 3 ? "" : "none",
  });
  const style5 = useSpring({
    left: mobileState ? x5 : mobileX5,
    display: positionX === 4 ? "" : "none",
  });
  const style6 = useSpring({
    left: mobileState ? x6 : mobileX6,
    display: positionX === 5 ? "" : "none",
  });

  const saveName = (e) => {
    if (my_name === null && e.target.name.value !== "") {
      sessionStorage.setItem("my_name", e.target.name.value);
      setName(e.target.name.value);
    }
  };
  const [shareBox, setShareBox] = useState(false);
  const [leaveGameModal, setLeaveGameModal] = useState(false);

  useEffect(() => {
    if (notification === true) {
      const interval = setInterval(() => {
        setNotification(false);
      }, 2000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification]);

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  useEffect(() => {
    if (robotPlayer === true) {
      if (player && !finished) {
        const interval = setInterval(() => {
          putInColumn(getRandomInt(6));
        }, 1500);
        return () => clearInterval(interval);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player, finished]);

  useEffect(() => {
    if (waitForReplay && robotPlayer) {
      setReplay(true);
      winner();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waitForReplay]);

  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-start bg-[url('/public/images/wood.jpg')]">
      <div className="relative w-auto min-h-screen md:w-auto px-auto md:px-16 pt-4 ">
        <div className="w-full flex justify-between">
          <button
            onClick={() => setLeaveGameModal(true)}
            className="rounded-md bg-[#eeede4] border z-20 px-4 py-2 hover:bg-[#d4d3ca]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
              />
            </svg>
          </button>
          <div className="bg-[#eeede4] px-4 rounded-md font-semibold flex justify-center items-center flex-col">
            <p>Score</p>
            <p>
              {playerOneScore} : {playerTwoScore}
            </p>
          </div>
          <div className="relative rounded-md z-20">
            {!robotPlayer && (
              <>
                <button
                  type="button"
                  className="rounded-md bg-[#eeede4] border px-4 py-2 hover:bg-[#d4d3ca]"
                  onClick={() => setShareBox(!shareBox)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75"
                    />
                  </svg>
                </button>
                {shareBox && (
                  <div className="absolute w-40 divide-y z-50 right-0 top-12 items-start border p-2 rounded-md flex flex-col bg-[#eeede4]">
                    <a
                      className="flex gap-x-2 items-center py-3 px-4 hover:font-bold transform duration-100"
                      href={`viber://forward/?text=https://rrath-rrath.netlify.app/game/${id.id}`}
                    >
                      <img
                        className="w-8 h-8"
                        alt="viberLogo"
                        src="/images/viber.png"
                      />{" "}
                      Viber
                    </a>
                    <a
                      className="flex gap-x-2 items-center py-2 px-4 hover:font-bold transform duration-100"
                      href={`whatsapp://send/?text=https://rrath-rrath.netlify.app/game/${id.id}`}
                    >
                      <img
                        className="w-8 h-8"
                        alt="whatsappLogo"
                        src="/images/whatsapp.png"
                      />{" "}
                      Whatsapp
                    </a>
                    <button
                      type="button"
                      className="whitespace-nowrap py-2 px-4 hover:font-bold transform duration-100"
                      onClick={() => {
                        navigator.clipboard.writeText(
                          `https://rrath-rrath.netlify.app/game/${id.id}`
                        );
                        setNotification(true);
                        setShareBox(false);
                      }}
                    >
                      Copy Link
                    </button>
                    <button
                      type="button"
                      className="whitespace-nowrap py-2 px-4 hover:font-bold transform duration-100"
                      onClick={() => {
                        navigator.clipboard.writeText(id.id);
                        setNotification(true);
                        setShareBox(false);
                      }}
                    >
                      Copy Game ID
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div className="w-full flex justify-between py-2">
          <div
            className={`px-2 md:px-4 py-1 md:py-2 border-2 ${
              player ? "" : "border-red-700"
            } transition duration-300 ease-in-out text-[14px] md:text-base rounded-full capitalize font-semibold bg-[#eeede4]`}
          >
            {playerOneName}
          </div>
          {playerTwoName !== "" && (
            <div
              className={`px-2 md:px-4 py-1 md:py-2 border-2 ${
                player ? "border-yellow-300" : ""
              } transition duration-300 ease-in-out text-[14px] md:text-base rounded-full capitalize font-semibold bg-[#eeede4]`}
            >
              {playerTwoName}
            </div>
          )}
        </div>
        <div
          className={`${
            notification ? "top-4 " : "-top-full"
          } absolute w-1/2 left-[25%] rounded-md z-50 transform duration-300 ease-in-out bg-[#eeede4] px-4 py-2 text-center text-green-500 border-2 border-green-500`}
        >
          Successfully copied.
        </div>
        <div className="relative border-blue-800 rounded-xl h-full flex flex-col-reverse border-2 bg-blue-700 mt-20 md:mt-32">
          {[style1, style2, style3, style4, style5, style6].map(
            (item, index) => (
              <animated.div
                style={{ ...styles, ...item }}
                key={index}
                className="absolute z-30"
              >
                <div
                  className={`${
                    player ? "bg-red-700" : "bg-yellow-300"
                  } w-12 md:w-24 h-12 md:h-24 rounded-full p-2`}
                >
                  <div className="shadow-lg shadow-black/20 w-full h-full transition delay-100 rounded-full"></div>
                </div>
              </animated.div>
            )
          )}
          <div className="w-full absolute -top-20 md:-top-32 h-12 md:h-24 flex justify-center overflow-hidden">
            <input
              disabled={activePlayer !== player ? true : false}
              onMouseUp={(e) => {
                if (activePlayer === player) {
                  putInColumn(e.target.value);
                  setPositionX(parseInt(e.target.value));
                }
              }}
              onTouchEnd={(e) => {
                if (activePlayer === player) {
                  putInColumn(e.target.value);
                  setPositionX(parseInt(e.target.value));
                }
              }}
              id="inputRange"
              className={`${
                player
                  ? mobileState
                    ? "verdh"
                    : "verdhMobile"
                  : mobileState
                  ? "kuq"
                  : "kuqMobile"
              } px-1 md:px-2`}
              type="range"
              min="0"
              max="5"
            />
          </div>
          {array.map((item, index) => (
            <div key={index} className="w-full grid grid-cols-6">
              {item.map((item2, index) => (
                <div
                  key={index}
                  className="w-full flex items-center justify-center p-1 md:p-2 "
                >
                  <div
                    className={` ${
                      item2 === true
                        ? "bg-yellow-300"
                        : item2 === false
                        ? "bg-red-700"
                        : "bg-white"
                    } w-12 md:w-24 h-12 transition delay-500 md:h-24 rounded-full p-2 ring ring-blue-900`}
                  >
                    <div
                      className={`${
                        item2 || item2 === false
                          ? "shadow-lg shadow-black/20"
                          : ""
                      } w-full h-full transition delay-500 rounded-full`}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div
        className={`absolute ${
          finished ? "block" : "hidden"
        } w-full h-screen px-8 z-10 top-0 bg-black/30 flex justify-center items-center`}
      >
        <div className="w-full md:w-1/3 text-center font-bold flex flex-col items-center justify-center bg-white rounded-xl py-8 px-16 ">
          <p className="text-xl pb-2">Game finished!</p>
          {draw && <p>Game finished without winner!</p>}
          {!draw && (
            <p className="pb-4">
              Winner of the game was{" "}
              <span
                className={`${
                  !player ? "text-yellow-300" : "text-red-700"
                } capitalize font-bold`}
              >
                {!player ? playerTwoName : playerOneName}
              </span>
              .
            </p>
          )}
          <div className="flex flex-col-reverse">
            {array.map((item, index) => (
              <div key={index} className="w-auto grid grid-cols-6">
                {item.map((item2, index) => (
                  <div
                    key={index}
                    className="w-full flex items-center justify-center p-1 md:p-2 "
                  >
                    <div
                      className={` ${
                        item2 === true
                          ? "bg-yellow-300"
                          : item2 === false
                          ? "bg-red-700"
                          : "bg-white"
                      } w-6 md:w-12 h-6 transition delay-500 md:h-12 rounded-full p-1 md:p-[6px] ring ring-blue-900`}
                    >
                      <div
                        className={`${
                          item2 || item2 === false
                            ? "shadow-lg shadow-black/20"
                            : ""
                        } w-full h-full transition delay-500 rounded-full`}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
          {!waitForReplay && (
            <button
              className="border rounded-lg px-4 py-2 text-lg mt-4 bg-white hover:bg-gray-100"
              onClick={() => {
                winner();
              }}
            >
              Play again
            </button>
          )}
          {waitForReplay && (
            <div className="animate-spin h-5 w-5 mt-4 rounded-full border-t border-red-700"></div>
          )}
        </div>
      </div>
      <div
        className={`absolute ${
          thirdPart ? "block" : "hidden"
        } w-full h-screen px-8 z-10 top-0 bg-black/30 flex justify-center items-center`}
      >
        <div className="w-full md:w-1/3 text-center font-bold flex space-y-4 flex-col items-center justify-center bg-white rounded-xl p-16 ">
          <p>
            You can not play in this game, you are the third player in game.
          </p>
          <a
            className="text-lg py-2 px-4 text-red-700 border bg-white hover:bg-gray-100 rounded-md"
            href="/"
          >
            Back to homepage
          </a>
        </div>
      </div>
      <div
        className={`${
          thirdPart === false && name === null ? "absolute" : "hidden"
        } w-full h-screen px-8 z-10 top-0 bg-black/30 flex justify-center items-center`}
      >
        <form
          onSubmit={(e) => saveName(e)}
          className="relative z-10 w-full md:w-1/3 flex flex-col items-center justify-center bg-white rounded-xl p-16 "
        >
          <input
            type="text"
            name="name"
            className="border outline-none focus:ring-2 ring-gray-300 px-4 py-2 rounded-lg"
            placeholder="Write your nickname"
            required
          />
          <button
            type="submit"
            className="border rounded-lg px-4 py-2 text-lg font-semibold mt-4 hover:bg-gray-100"
          >
            Save
          </button>
        </form>
      </div>
      <div
        className={`absolute ${
          leaveGameModal ? "block" : "hidden"
        } w-full h-screen px-8 z-10 top-0 bg-black/30 flex justify-center items-center`}
      >
        <div className="w-full md:w-1/3 text-center font-bold flex space-y-4 flex-col items-center justify-center bg-white rounded-xl p-16 ">
          <p>Are you sure you want to leave the game?</p>
          <div className="flex gap-x-4">
            <a
              className="text-lg py-2 px-4 border bg-white hover:bg-gray-100 rounded-md"
              href="/"
            >
              Yes
            </a>
            <button
              className="text-lg py-2 px-4 border bg-white hover:bg-gray-100 rounded-md"
              onClick={() => setLeaveGameModal(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Game;
